import { Features } from 'generated/featureDefinitions'
import { AvailableModules } from 'generated/featureDefinitions'
import { GetFeatureAvailabilitiesDocument } from 'generated/resources/graphql'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useQuery } from 'modules/core/hooks/useQuery'
import { isFeatureAvailabilityEnabled } from 'modules/core/lib/isFeatureAvailabilityEnabled'

type CanSeeYearlyBalanceData = {
  loading: boolean
  canSeeYearlyBalance: boolean
}

const useCanSeeYearlyBalance = (): CanSeeYearlyBalanceData => {
  const { company: currentCompany } = useCurrentSession()
  const { loading: loadingFeatures, data: featuresData } = useQuery(
    GetFeatureAvailabilitiesDocument,
    {
      fetchPolicy: 'cache-first',
      variables: {
        modules: [AvailableModules.time_balance],
        companyId: currentCompany.id,
      },
    }
  )

  if (loadingFeatures) {
    return { loading: true, canSeeYearlyBalance: false }
  }

  const featureAvailabilities = featuresData?.companies.featureAvailabilities || []

  const canSeeYearlyBalance = isFeatureAvailabilityEnabled(
    featureAvailabilities,
    Features.time_balance_annualisation_export
  )

  return { loading: loadingFeatures, canSeeYearlyBalance }
}

export default useCanSeeYearlyBalance
